import { isReference } from '@medplum/core';
import { Patient, Reference, Resource } from '@medplum/fhirtypes';

// -----------------------------------------------------------------------------
export const getResourceUrl = <T extends Resource>(resource: T): string => {
  // Special case: Encounters should always navigate to /Encounter/:id
  if (resource.resourceType === 'Encounter') {
    return `/Encounter/${resource.id}`;
  }
  const patientFields = ['patient', 'subject', 'sender'] as (keyof T)[];
  for (const key of patientFields) {
    if (key in resource) {
      const value = resource[key];
      if (isPatientReference(value)) {
        return `/${value.reference}/${resource.resourceType}/${resource.id}`;
      }
    }
  }
  return `/${resource.resourceType}/${resource.id}`;
};

// -----------------------------------------------------------------------------
const isPatientReference = (
  input: unknown
): input is Reference<Patient> & { reference: string } => {
  return isReference(input) && input.reference.startsWith('Patient/');
};
